export default __webpack_public_path__ + "static/travel-footer-f44eb667da1a7fabbf5d8e2b37ae9e65.png";